import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Breadcrumb/BreadcrumbItem.js",
  _templateObject,
  _this = this;
import React from 'react';
import { ArrowRight } from '@dls/assets/icons';
import { withTheme, useTheme } from '../../core/ThemeProvider';
import { withStyledAttrs } from '../../helpers/styled';
import Text from '../Text';
import styled, { css } from 'styled-components';
export var BreadcrumbText = withStyledAttrs(Text, {
  type: 'smallBody',
  fontWeight: 'thin',
  tag: 'span'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n"])));
export var BreadcrumbItemContainer = withTheme(styled.span.withConfig({
  displayName: "BreadcrumbItem__BreadcrumbItemContainer",
  componentId: "sc-1b6xx17-0"
})(function (_ref) {
  var coreTheme = _ref.coreTheme;
  return css([".separator{vertical-align:sub;padding-left:5px;padding-right:5px;@media (min-width:", "){padding-left:10px;padding-right:10px;}}"], coreTheme.brk_xs);
}));
var BreadcrumbItem = function BreadcrumbItem(_ref2) {
  var children = _ref2.children,
    onClick = _ref2.onClick,
    className = _ref2.className;
  var _useTheme = useTheme(),
    theme = _useTheme.theme;
  return /*#__PURE__*/React.createElement(BreadcrumbItemContainer, {
    className: className,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 37,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(BreadcrumbText, {
    onClick: onClick,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 7
    }
  }, children), /*#__PURE__*/React.createElement(ArrowRight, {
    className: "separator",
    size: 16,
    color: theme.cl_ter_l4,
    stroke: theme.cl_ter_l4,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 7
    }
  }));
};
export default BreadcrumbItem;